<template>
  <div class="sliderController">
    <button @click="handleSlidePrev" class="slideCtnPrev"></button>
    <button @click="handleAutoSlideToggle" :class="[this.slideAutoStart ? slideCtnPause : slideCtnStart]"></button>
    <button @click="handleSlideNext" class="slideCtnNext"></button>
  </div>
</template>

<script>
    export default {
        name: "SliderController",
        props : ['sliderInterval'],
        data () {
          return {
            slideAutoStart : true,
            interval : this.sliderInterval,
            slideCtnPause : 'slideCtnPause' ,
            slideCtnStart : 'slideCtnStart',


          }
        },
        computed : {
        },
        methods : {
          handleSlideNext() {
            this.$parent.$refs.slider.$emit('slideNext');
          },
          handleSlidePrev() {
            this.$parent.$refs.slider.$emit('slidePre');
          },
          handleAutoSlideToggle() {
            //console.log(')
            //console.log(this.sliderInterval);
            /*console.log('slide');
            if(this.slideAutoStart) {
              this.$parent.$refs.slider.$emit('autoplayStop');
              this.slideAutoStart = false;
            }
            else {
              this.$parent.$refs.slider.$emit('autoplayStart', this.interval);
              this.slideAutoStart = true;
            }*/



            this.slideAutoStart = !this.slideAutoStart;
            this.$emit('autoPlayToggle' , this.slideAutoStart);

          },
        }

    }
</script>

<style scoped lang="scss">
  @import "@/styles/Global.scss";

  .sliderController {
    position: absolute;
    z-index: 1;
    bottom: 15%;
    right: 10%;
    width: 150px;
    height: 40px;
    border: 1px solid #ffffff;
    display: flex;
    @include respond-to('medium') {
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
    >button {
      border:0;
      background-color: transparent;
      color:#fff;
      width:calc(100%/3);
      border-right:1px solid #fff;
      cursor:pointer;
      &:last-child{
        border-right:0;
      }
      &:focus {
        outline:0;
      }
      &.slideCtnPause {
        background-image : url(https://s3.ap-northeast-2.amazonaws.com/sf-sunnyfactory/images/buttons/pause-button.png);
        background-repeat: no-repeat;
        background-size: 30%;
        background-position: center;
      }
      &.slideCtnStart {
        background : url(https://s3.ap-northeast-2.amazonaws.com/sf-sunnyfactory/images/buttons/play-button.png);
        background-repeat: no-repeat;
        background-size: 30%;
        background-position: center;
      }
      &.slideCtnNext {
        background-image : url(https://s3.ap-northeast-2.amazonaws.com/sf-sunnyfactory/images/buttons/next-button.png);
        background-repeat: no-repeat;
        background-size: 30%;
        background-position: center;
      }
      &.slideCtnPrev {
        background : url(https://s3.ap-northeast-2.amazonaws.com/sf-sunnyfactory/images/buttons/prev-button.png);
        background-repeat: no-repeat;
        background-size: 30%;
        background-position: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SliderController.vue